export const EDITOR_DND_TYPES = {
  PALETTE: 'EDITOR_PALETTE',
  CANVAS_ITEM: 'EDITOR_CANVAS_ITEM',
} as const;

export type EditorDndType =
  (typeof EDITOR_DND_TYPES)[keyof typeof EDITOR_DND_TYPES];
